import React, { useState, useRef, useEffect, useContext, useCallback } from "react";
import { useForm } from "react-hook-form";
import "../../Complaint.css";
import "bootstrap/dist/css/bootstrap.min.css";
import CommonContainer from "../Container/CommonContainer";
import { FaExclamationTriangle, FaFlask, FaDownload, FaSearch, FaSpinner, FaInfoCircle, FaCheckCircle, FaToggleOn, FaToggleOff, FaPen, FaTrash, FaTimesCircle, FaClock, FaPaperPlane, FaExclamationCircle, FaFileDownload, FaArrowDown, FaComments, FaFilter, FaCaretDown, FaIcons, FaUserNurse, FaFileExcel, FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import toast from "react-hot-toast";
import 'react-datepicker/dist/react-datepicker.css';
import LoadingSpinnerComponent from "../Loader/LoadingSpinnerComponent";
import * as PartnerService from '../../Services/Partner/PartnerService'
import * as AccountService from '../../Services/Account/AccountService'
import { useSelector } from "react-redux";
import ReactDatePicker from 'react-datepicker';
import { formatVisitDate, API_DOMAIN, formatDate } from "../../Common/CommonVariables";

import { Tooltip } from 'react-tooltip';
import Popover from '../../Common/Popper';
import { AlertTriangle, Eye, EyeOff, Plus } from 'lucide-react';
import { Calendar } from "lucide-react";
import { AlarmClock } from 'lucide-react';
import { isBefore, isAfter, parseISO, set, subDays, startOfDay, endOfDay } from 'date-fns';
import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../Common/CommonVariables'
import { saveAs } from 'file-saver';
import { useLocation } from "react-router-dom";
import { store } from '../../Store/store';
import "./PatientVisitComponent.css";
import CommonPagination from "../../Common/CommonPagination";
import PatientTestDetailsModalComponent from "./PatientTestDetailsModalComponent";
import { format } from "date-fns";
import { useBulkPatientReportDownload, useDownloadPatientListExcelRights, useDownloadWOSReport, useDownloadWSReport, useRaiseComplaintRights, useSendWSReportOnEmail, useSendWOSReportOnEmail } from "../../Common/CommonAccessFile";
import * as XLSX from "xlsx";
import RaiseComplaint from "../PartnerCase/RaiseComplaintModalComponent";

const parseTatDate = (str) => {
    if (!str) return 0;
    const match = /^(\d{2})-(\d{2})-(\d{4})\s+(\d{2}):(\d{2})\s*(AM|PM)$/i.exec(str.trim());
    if (!match) return 0;
    let [, dd, mm, yyyy, hh, min, ampm] = match;
    hh = parseInt(hh, 10);
    if (/pm/i.test(ampm) && hh !== 12) hh += 12;
    if (/am/i.test(ampm) && hh === 12) hh = 0;
    return new Date(Number(yyyy), Number(mm) - 1, Number(dd), hh, Number(min)).getTime();
};

const PatientVisitComponent = () => {
    const accessToSendWS_ReportOnEmail = useSendWSReportOnEmail();
    const accessToSendWOS_ReportOnEmail = useSendWOSReportOnEmail();
    const accessToDownloadReport = useBulkPatientReportDownload()
    const accessToDownloadWOSReport = useDownloadWOSReport()
    const accessToDownloadWSReport = useDownloadWSReport()
    const accessToDownloadPatientListExcelRights = useDownloadPatientListExcelRights()
    const accessToRaiseComplaintRights = useRaiseComplaintRights();

    const [patientReportList, setPatientReportList] = useState([]);

    const selectedOrg = useSelector((state) => state.selectedOrganization);

    const [loading, setLoading] = useState(false);
    const [emailSendLoading, setEmailSendLoading] = useState(false);
    const [SearchLoading, setSearchLoading] = useState(false);
    const selectedSearchPR = useRef();

    const [vidDateSort, setVidDateSort] = useState(null);
    const [tatSort, setTatSort] = useState(null);

    const handleVidDateSort = () => {
        setTatSort(null);
        setVidDateSort(prev => prev === null ? "asc" : prev === "asc" ? "desc" : null);
        setCurrentPage(1);
    };

    const handleTatSort = () => {
        setVidDateSort(null);
        setTatSort(prev => prev === null ? "asc" : prev === "asc" ? "desc" : null);
        setCurrentPage(1);
    };

    const sortedPatientReportList = [...patientReportList].sort((a, b) => {
        if (vidDateSort) {
            const dateA = new Date(a.MHL_Visit_Date__c || 0);
            const dateB = new Date(b.MHL_Visit_Date__c || 0);
            return vidDateSort === "asc" ? dateA - dateB : dateB - dateA;
        }
        if (tatSort) {
            const timeA = parseTatDate(a.MHL_Test_TAT_Date);
            const timeB = parseTatDate(b.MHL_Test_TAT_Date);
            return tatSort === "asc" ? timeA - timeB : timeB - timeA;
        }
        return 0;
    });

    const availableReports = sortedPatientReportList.filter(rec => rec.PP_ReportStatus__c === "AVAILABLE");

    // Pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // Set number of items per page

    //Pagination logic for available reports
    const indexOfLastAvailable = currentPage * itemsPerPage;
    const indexOfFirstAvailable = indexOfLastAvailable - itemsPerPage;
    const currentAvailableReports = availableReports.slice(indexOfFirstAvailable, indexOfLastAvailable);

    // Pagination logic
    const indexOfLastPatientRPT = currentPage * itemsPerPage;
    const indexOfFirstPatientRPT = indexOfLastPatientRPT - itemsPerPage;
    const currentPatientReport = sortedPatientReportList.slice(indexOfFirstPatientRPT, indexOfLastPatientRPT);

    const availableOrganizationData = useSelector((state) => state.availableOrganizationData);

    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [dateRangeOption, setDateRangeOption] = useState('Today');

    const startDateRef = useRef(null);
    const endDateRef = useRef(null);
    const [TodayDate, setTodayDate] = useState(new Date());

    const [selectedURL, setSelectedURL] = useState('');

    const [sendReportModalShow, setSendReportModalShow] = useState(false);

    const { register, formState: { errors }, reset, handleSubmit } = useForm();
    const [reportEmail, setReportEmail] = useState("");
    const [selectedReportType, setSelectedReportType] = useState("");
    const [selectedPatient, setSelectedPatient] = useState([]);
    const [showTooltip, setShowTooltip] = useState(false);

    const [showBulkDownloadReportOptionModal, setShowBulkDownloadReportOptionModal] = useState(false);
    const [downloadOption, setDownloadOption] = useState("");
    const [showRaiseComplaintModal, setShowRaiseComplaintModal] = useState(false)
    const [selectedVID, setSelectedVID] = useState(null);

    const [showFilter, setShowFilter] = useState(false);
    const [reportFilter, setReportFilter] = useState("");

    const handleFilterClick = (filterValue) => {
        setReportFilter(filterValue);
        setShowFilter(false);
    };


    const handleRaiseComplaint = () => {
        setShowRaiseComplaintModal(true)
    }

    const handleSendReportClick = (rec) => {
        //console.log("reportURL", patientReportList)
        setSelectedPatient(rec);
        setSendReportModalShow(true)
    }

    const onSubmit = (data) => {
        setEmailSendLoading(true);
        //console.log(selectedPatient);
        //debugger;
        let req_reportUrl = null
        if (data.Report_Type === "WS") {
            req_reportUrl = selectedPatient.WS_Report__c
        }
        else {
            req_reportUrl = selectedPatient.WOS_Report__c
        }

        const emailArray = data.Email
            .split(',')
            .map(email => email.trim()) // removes extra spaces
            .filter(email => email);    // removes empty entries

        const sendReportDet = {
            FileURL: req_reportUrl,
            VID: selectedPatient.MHL_ExternalVID__c,
            Visit_Date: formatVisitDate(selectedPatient.MHL_Visit_Date__c),
            To_Email: emailArray,
            PID: selectedPatient.MHL_PID__c,
            Is_With_Stationary: data.Report_Type === "WS" ? true : false,
            Is_Without_Stationary: data.Report_Type === "WOS" ? true : false,
            Test_Owner_MailId: selectedPatient.MHL_Patient_Email
        }

        //debugger;

        PartnerService.SendReportOnEmail(sendReportDet)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    toast.success("Report sent on email")
                    handleSendReportModalClose();
                }
                else {
                    toast.error(data.ResponseMessage)
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => setEmailSendLoading(false));
    }

    const formatDateToUTC = (date) => {
        const d = new Date(date);
        return d.toISOString().split('T')[0] + 'T00:00:00Z';
    };

    const location = useLocation();
    const { filter } = location.state || {};

    const [initDone, setInitDone] = useState(false);

    const userInfo = store.getState();
    const userData = userInfo?.userData || {};

    useEffect(() => {
        if (filter) {
            setReportFilter(filter);
        }
    }, [filter]);

    useEffect(() => {
        if (!initDone && location.state) {
            const { startDate: passedStartDate, endDate: passedEndDate, dateRangeOption: passedOption } = location.state;

            if (passedStartDate && endDate) {
                setDateRangeOption(passedOption || 'Custom');
                setStartDate(new Date(passedStartDate));
                setEndDate(new Date(passedEndDate));
                setInitDone(true); // Prevents re-running this logic
            }
        }
    }, [location.state, initDone]);

    useEffect(() => {
        if (initDone && startDate && endDate) {
            fetchPtientReportList();
        }
    }, [initDone, startDate, endDate, dateRangeOption]);


    useEffect(() => {
        if (startDate && endDate) {
            fetchPtientReportList();
        }
    }, [dateRangeOption]);


    const fetchPtientReportList = useCallback(() => {
        if (!selectedOrg) {
            toast.error("No organization selected.");
            setPatientReportList([]);
            return;
        }

        if (dateRangeOption === "Custom") {
            if (!startDate || !endDate) {
                toast.error("Please select both Start Date and End Date for Custom range");
                return;
            }
        }

        if (startDate > endDate) {
            toast.error("Start date cannot be after end date");
            return;
        }

        if (endDate > new Date()) {
            toast.error("End date cannot be of future");
            return;
        }

        setSearchLoading(true);
        setLoading(true);

        const requestData = {
            // StartDate: formatDateToUTC(startDate),
            StartDate: startDate
                ? new Date(new Date(startDate).setHours(0, 0, 0, 0)).toISOString()
                : null,
            EndDate: endDate
                ? new Date(new Date(endDate).setHours(23, 59, 59, 999)).toISOString()
                : null,
            Org_Id: selectedOrg.MHL_Org_Id__c
        };

        //debugger;
        PartnerService.GetPatientVisitDataList(requestData)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    //debugger;
                    setPatientReportList(data.Data);
                } else {
                    setPatientReportList([]);
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => {
                setLoading(false);
                setSearchLoading(false);
            });
    }, [selectedOrg, startDate, endDate, dateRangeOption]);


    // useEffect(() => {
    //     if (location.state) {
    //         const { startDate: passedStartDate, endDate: passedEndDate, dateRangeOption: dateRangeOption } = location.state;

    //         if (passedStartDate && passedEndDate) {
    //             setDateRangeOption(dateRangeOption);
    //             setStartDate(new Date(passedStartDate));
    //             setEndDate(new Date(passedEndDate));
    //         }
    //     }
    // }, [location.state]);

    useEffect(() => {
        if (selectedOrg) {
            fetchPtientReportList();
        }
    }, [selectedOrg]);


    const fetchUniversalFilterReportData = () => {
        //debugger;
        if (!selectedOrg) {
            setPatientReportList([])
            return;
        }

        if (selectedSearchPR.current.value == null || selectedSearchPR.current.value == "") {
            window.location.reload();
            // toast.error("Please enter search data.")
            return;
        }
        // setLoading(true);
        setSearchLoading(true);
        PartnerService.GetUniversalPatientVisitDataList(selectedSearchPR.current.value, selectedOrg.MHL_Org_Id__c)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    setPatientReportList(data.Data);
                }
                else {
                    setPatientReportList([])
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => setSearchLoading(false));
    };

    const [showPatientTestTATModal, setshowPatientTestTATModal] = useState(false);
    const [TestDetailsbyVID, setTestDetailsbyVID] = useState([]);
    const handlePatientTestTATClose = () => setshowPatientTestTATModal(false);
    const handleSendReportModalClose = () => {
        reset();
        setSendReportModalShow(false)
    }

    const [patient, setPatient] = useState({});
    const [visit, setVisit] = useState({});
    const [samples, setSamples] = useState([]);
    const [tests, setTests] = useState([]);
    const [reportURL, setReportURL] = useState("");
    const [reportWOSURL, setReportWOSURL] = useState("");
    const [visitStatus, setVisitStatus] = useState("");
    const [crmVisitDetails, setCRMVisitDetails] = useState([]);

    // const patient = data?.PatientDemographics || {};
    // const visit = data?.PatientVisitDetails || {};
    // const samples = data?.SampleInfoList || [];
    // const tests = data?.TestOrderDetails || [];
    // const reportURL = data?.ReportS3URL;
    // const reportWOSURL = data?.ReportWOSS3URL;

    const GetPatientTestDetailTAT = (data) => {

        setSearchLoading(true);
        setCRMVisitDetails(data);
        PartnerService.GetPatientTestsDetailsByVID(data.Name, data.MHL_OrgId__C)
            .then(({ data }) => {
                //debugger;
                if (data.IsSuccess) {
                    setshowPatientTestTATModal(true);
                    const response = data.Data;

                    setPatient(response.PatientDemographics || {});
                    setVisit(response.PatientVisitDetails || {});
                    setSamples(response.SampleInfoList || []);
                    setTests(response.TestOrderDetails || []);
                    setReportURL(response.ReportS3URL || "");
                    setReportWOSURL(response.ReportWOSS3URL || "");
                    setVisitStatus(response.VisitStatus || "");

                    // setPatientReportList(data.Data);
                }
                else {
                    // setPatientReportList([])
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => setSearchLoading(false));
        // setTestDetailsbyVID(data.MHL_Test_Details_List);
    }

    const handleDateRangeChange = (e) => {
        const selected = e.target.value;
        setDateRangeOption(selected);

        const today = new Date();
        let start = null;
        let end = null;

        switch (selected) {
            case 'Today':
                start = new Date();
                end = new Date();
                break;
            case 'Yesterday':
                start = new Date();
                start.setDate(start.getDate() - 1);
                end = new Date(start);
                break;
            case 'Current Week':
                start = new Date();
                start.setDate(start.getDate() - start.getDay());
                end = new Date();
                break;
            case 'Last 7 Days':
                start = new Date();
                start.setDate(start.getDate() - 6);
                end = new Date();
                break;
            case 'MTD':
                start = new Date(today.getFullYear(), today.getMonth(), 1);
                end = new Date();
                break;
            case 'Last 30 Days':
                start = new Date();
                start.setDate(start.getDate() - 29);
                end = new Date();
                break;
            case 'Custom':
                start = null;
                end = null;
                break;
            default:
                break;
        }

        setStartDate(start);
        setEndDate(end);
    };

    const [showPopup, setShowPopup] = useState(false);

    const handleDownloadWithStationary = () => {
        // Your download logic for "with stationary"
        setShowPopup(false);
    };

    const handleDownloadWithoutStationary = () => {
        // Your download logic for "without stationary"
        setShowPopup(false);
    };


    const handleDownload = async () => {
        if (!selectedURL) {
            toast.error("Please select report type first.");
            return;
        }

        const requestUrl = `${API_DOMAIN}Account/Download?url=${encodeURIComponent(selectedURL)}`;

        try {
            const response = await trackPromise(
                axios.get(requestUrl, CommonVariables.API_HEADER)
            );

            const fileUrl = response.data.Data; // assuming the API returns a direct URL to open
            if (fileUrl) {
                window.open(fileUrl, '_blank');
            } else {
                toast.error('File URL is empty.');
            }

        } catch (error) {
            console.error('Download failed:', error);
            toast.error('Download failed.');
        }
    };


    const handleReportDownload = async (reportURL) => {

        const requestUrl = `${API_DOMAIN}Account/Download?url=${encodeURIComponent(reportURL)}`;

        try {
            const response = await trackPromise(
                axios.get(requestUrl, CommonVariables.API_HEADER)
            );

            const fileUrl = response.data.Data; // assuming the API returns a direct URL to open
            if (fileUrl) {
                window.open(fileUrl, '_blank');
            } else {
                toast.error('File URL is empty.');
            }

        } catch (error) {
            console.error('Download failed:', error);
            toast.error('Download failed.');
        }
    };

    const currentDateTime = new Date();

    const formattedDateTime = new Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    }).format(currentDateTime);


    const [selectedAvailableReports, setSelectedAvailableReports] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    // Handle individual row selection
    const handleCheckboxChange = (rec) => {
        //debugger;
        const exists = selectedAvailableReports.find(r => r.Name === rec.Name);
        if (exists) {
            // Remove from selected
            const updated = selectedAvailableReports.filter(r => r.Name !== rec.Name);
            setSelectedAvailableReports(updated);
            setSelectAll(false); // Deselect 'Select All' if even one is unchecked
        } else {
            // Add with full structure
            const updated = [
                ...selectedAvailableReports,
                {
                    Name: rec.Name,
                    Patient_Name: rec.MHL_Patient_Name,
                    ReportURl: rec.WS_Report__c,
                    WOS_ReportURl: rec.WOS_Report__c,
                },
            ];
            setSelectedAvailableReports(updated);

            // If all available reports are now selected, enable 'Select All'
            const availableRecords = patientReportList.filter(r => r.PP_ReportStatus__c === "AVAILABLE");
            if (updated.length === availableRecords.length) {
                setSelectAll(true);
            }
        }
    };

    // Handle select all toggle
    const handleSelectAll = () => {
        const availableRecords = patientReportList.filter(
            (rec) => rec.PP_ReportStatus__c === "AVAILABLE"
        );

        if (selectAll) {
            // Unselect all
            setSelectedAvailableReports([]);
        } else {
            // Select all available
            const selected = availableRecords.map(rec => ({
                Name: rec.Name,
                Patient_Name: rec.MHL_Patient_Name,
                ReportURl: rec.WS_Report__c,
                WOS_ReportURl: rec.WOS_Report__c,
            }));
            setSelectedAvailableReports(selected);
        }
        setSelectAll(!selectAll);
    };


    // Check if a row is selected
    const isChecked = (Name) => selectedAvailableReports.some(r => r.Name === Name);

    const handleProceed = () => {
        //debugger;
        if (downloadOption) {
            handleBulkReportDownload(downloadOption);
            setShowBulkDownloadReportOptionModal(false);
        } else {
            alert("Please select one option.");
        }
    };

    const handleBulkReportDownload = async (filterType) => {
        setSearchLoading(true);
        //debugger;
        const requestData = {
            BulkReportData: selectedAvailableReports,
            Is_WSReport: filterType == "with",
            Is_WOSReport: filterType == "without",
        };

        try {
            const response = await trackPromise(axios.post(
                `${API_DOMAIN}Account/BulkReportDownload`,
                requestData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    responseType: 'blob',
                }
            ));
            const filename = `PatientReport_${new Date().toISOString().replace(/[:.]/g, '-')}.zip`;

            const blob = new Blob([response.data], { type: 'application/zip' });
            saveAs(blob, filename);
        } catch (error) {
            console.error('Download failed:', error);
            toast.error("Failed to download ZIP.");
        } finally {
            setSearchLoading(false);
        }
    };

    const downloadExcel = (data) => {
        // Convert JSON data to worksheet
        const worksheet = XLSX.utils.json_to_sheet(data);

        // Create a new workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

        // Generate buffer
        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        // Save the file
        const fileData = new Blob([excelBuffer], {
            type: "application/octet-stream",
        });
        saveAs(fileData, "PatientVisits_Report.xlsx");
    };

    const handlePatientVisitReportDownloadClick = (data) => {
        // const exportData = data.map(item => ({
        //     "PID": item.MHL_PID__c,
        //     "Patient Name": item.MHL_Patient_Name,
        //     "Patient Gender": item.MHL_Patient_Gender,
        //     "Patient DOB": format(parseISO(item.MHL_Patient_DOB), "dd-MMM-yyyy"),
        //     "VID": item.Name,
        //     "VID Date": formatVisitDate(item.MHL_Visit_Date__c),
        //     "Test Name": Array.isArray(item.MHL_Test_Details_List)
        //         ? item.MHL_Test_Details_List.map(test => test.MHL_TestName__c).join(", ")
        //         : "",
        //     "TAT": item.MHL_Visit_Status__c === "Cancelled"
        //         ? "N/A"
        //         : item.MHL_Test_TAT_Date || "-",
        //     "Report Status": item.PP_ReportStatus__c,
        // }));
        // downloadExcel(exportData);

        const payload = data.map(item => ({
            "PID": item.MHL_PID__c,
            "Patient_Name": item.MHL_Patient_Name,
            "Patient_Gender": item.MHL_Patient_Gender,
            "Patient_DOB": format(parseISO(item.MHL_Patient_DOB), "dd-MMM-yyyy"),
            "VID": item.Name,
            "VID_Date": formatVisitDate(item.MHL_Visit_Date__c),
            "Test_Name": Array.isArray(item.MHL_Test_Details_List)
                ? item.MHL_Test_Details_List.map(test => test.MHL_TestName__c).join(", ")
                : "",
            "TAT": item.MHL_Visit_Status__c === "Cancelled"
                ? "N/A"
                : item.MHL_Test_TAT_Date || "-",
            "Report_Status": item.PP_ReportStatus__c,
        }));

        AccountService.PatientVisitExcelDownload(payload)
            .then(({ data }) => {
                //debugger;

                if (data.IsSuccess) {
                    const base64Data = data.Data;
                    const byteCharacters = atob(base64Data);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: "text/csv" });

                    //Trigger browser download
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute(
                        "download",
                        `PatientVisits_${new Date().toISOString().replace(/[-:T.Z]/g, "").slice(0, 14)}.csv`
                    );
                    document.body.appendChild(link);
                    link.click();
                    link.remove();

                    window.URL.revokeObjectURL(url); // clean up

                    toast.success("File downloaded successfully!");
                }
                else {
                    toast.error("Failed to downloaded!");
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => setSearchLoading(false));
    }

    const filteredReports = reportFilter === "AVAILABLE"
        ? availableReports
        : patientReportList.filter((rec) => {
            if (!reportFilter) return true;
            if (reportFilter === "Cancelled") return rec.MHL_Visit_Status__c === "Cancelled";
            return rec.PP_ReportStatus__c === reportFilter;
        });

    const filterDropdownRef = useRef(null);

    useEffect(() => {
        if (!showFilter) return;

        const handleClickOutside = (event) => {
            if (
                filterDropdownRef.current &&
                !filterDropdownRef.current.contains(event.target)
            ) {
                setShowFilter(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showFilter]);


    return (
        <>
            <CommonContainer
                icon={<FaUserNurse size={20} />}
                heading="Patient Visits"
                subHeading={
                    <p className="mb-2" style={{ fontSize: "10px" }}>
                        <strong style={{ color: "red" }}>Note:</strong> Org selection is mandatory
                    </p>
                }
                buttonText=""
                onButtonClick={() => { }}
            >
                <div className="d-flex flex-column flex-lg-row justify-content-between">
                    <div className="d-flex flex-column flex-lg-row gap-2 justify-content-between mb-2">
                        <div className="d-flex flex-column flex-md-row gap-1 align-items-md-center">

                            <select
                                className="form-select patient-visit-form-select mb-2 mb-md-0"
                                style={{ maxWidth: "200px" }}
                                value={dateRangeOption}
                                onChange={handleDateRangeChange}
                            >
                                <option value="Today">Today</option>
                                <option value="Yesterday">Yesterday</option>
                                <option value="Current Week">Current Week</option>
                                <option value="Last 7 Days">Last 7 Days</option>
                                <option value="MTD">MTD</option>
                                <option value="Last 30 Days">Last 30 Days</option>
                                <option value="Custom">Custom</option>
                            </select>


                            {(dateRangeOption === "Custom") && (
                                <>
                                    <div className="position-relative mb-2 mb-md-0">
                                        <ReactDatePicker
                                            selected={startDate}
                                            onChange={(date) => setStartDate(date)}
                                            className="form-control"
                                            dateFormat="dd-MM-yyyy"
                                            placeholderText="Select Start Date"
                                            ref={startDateRef}
                                        />
                                        <Calendar
                                            size={20}
                                            className="position-absolute "
                                            style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }}
                                            onClick={() => startDateRef.current.setFocus()}
                                        />
                                    </div>

                                    <div className="position-relative mb-2 mb-md-0">
                                        <ReactDatePicker
                                            selected={endDate}
                                            onChange={(date) => setEndDate(date)}
                                            className="form-control mobile-style"
                                            dateFormat="dd-MM-yyyy"
                                            placeholderText="Select End Date"
                                            ref={endDateRef}
                                        />
                                        <Calendar
                                            size={20} className="position-absolute"
                                            style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }}
                                            onClick={() => endDateRef.current.setFocus()}
                                        />
                                    </div>
                                </>
                            )}

                            <div className="d-flex gap-1 align-items-center">
                                <button
                                    className="btn custom-sumbitbtn d-flex align-items-center justify-content-center patient-visit-search-btn"
                                    // style={{ height: "35px", padding: "0" }}
                                    onClick={fetchPtientReportList}
                                    disabled={SearchLoading}
                                >
                                    {SearchLoading ? <FaSpinner className="fa-spin" /> : <b>GO</b>}
                                </button>
                                {selectedAvailableReports.length > 0 && (
                                    <button
                                        className="download-record-btn-wrapper"
                                        title="Download Selected Report Info"
                                        // onClick={handleBulkReportDownload}
                                        onClick={() => setShowBulkDownloadReportOptionModal(true)}
                                        disabled={SearchLoading}
                                    // Tooltip=""
                                    >
                                        <FaDownload className="download-record-btn" />
                                    </button>
                                )}

                                {/*  Download Record Button  */}
                                {currentPatientReport.length > 0 && accessToDownloadPatientListExcelRights &&
                                    <button className="download-record-btn-wrapper"
                                        title="Download Patient Visit List"
                                        onClick={() => handlePatientVisitReportDownloadClick(patientReportList)}
                                        disabled={loading}
                                    >
                                        <FaFileExcel
                                            className="download-record-btn"
                                        />
                                        {/* </button> */}
                                    </button>
                                }
                            </div>

                            <div className="my-2">
                                {SearchLoading ?
                                    <CommonVariables.LoadingMessage />
                                    : null}
                            </div>

                        </div>
                    </div>

                    <div className="search-box patient-visit-search-box" style={{ position: "relative", width: "320px" }}>
                        <div>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search by Name, PID, VID, TRF ID"
                                ref={selectedSearchPR}
                                style={{
                                    paddingRight: "35px",
                                    borderRadius: "5px",
                                    border: "1px solid #ddd",
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        fetchUniversalFilterReportData();
                                    }
                                }}
                            />
                            <button
                                className="btn custom-sumbitbtn d-flex align-items-center justify-content-center patient-visit-search-box-search-btn"
                                style={{
                                    padding: '5px',
                                    position: "absolute",
                                    top: "0",
                                    right: "0px",
                                    height: "35px",
                                    width: "45px",
                                    // top: "49% !important",
                                    borderTopLeftRadius: "0",
                                    borderBottomLeftRadius: "0",
                                    // transform: "translateY(-60%)"
                                }}

                                onClick={fetchUniversalFilterReportData}
                                disabled={SearchLoading}
                            >
                                <FaSearch />
                                {/* <span className="ms-2 d-md-none">Search</span> */}
                            </button>
                        </div>
                    </div>
                </div>


                <div>
                    <div className="table-responsive" >
                        <table className="table table-bordered custom-table" >
                            <thead>
                                <tr>
                                    {accessToDownloadReport && (accessToDownloadWOSReport || accessToDownloadWSReport) && (
                                        <th style={{ width: "3%" }}>
                                            <input
                                                type="checkbox"
                                                onChange={handleSelectAll}
                                                checked={selectAll}
                                                title="Select All AVAILABLE"
                                            />
                                        </th>
                                    )}

                                    <th style={{ width: "12%" }} > PID </th>
                                    <th style={{ width: "16%" }}> Patient Name </th>
                                    {/* <th style={{ width: "5%" }}> Doctor </th> */}
                                    <th style={{ width: "20%" }} > VID </th>
                                    <th style={{ width: "8%", cursor: "pointer", userSelect: "none" }} onClick={handleVidDateSort}>
                                        VID Date{" "}
                                        {vidDateSort === "asc" ? <FaSortUp style={{ marginLeft: 4, color: "white" }} /> : vidDateSort === "desc" ? <FaSortDown style={{ marginLeft: 4, color: "white" }} /> : <FaSort style={{ marginLeft: 4, color: "white" }} />}
                                    </th>
                                    <th style={{ width: "15%" }}> Test Name </th>
                                    <th style={{ width: "8%", cursor: "pointer", userSelect: "none" }} onClick={handleTatSort}>
                                        TAT{" "}
                                        {tatSort === "asc" ? <FaSortUp style={{ marginLeft: 4, color: "white" }} /> : tatSort === "desc" ? <FaSortDown style={{ marginLeft: 4, color: "white" }} /> : <FaSort style={{ marginLeft: 4, color: "white" }} />}
                                    </th>
                                    {/* <th style={{ width: "10%" }}> Report Status </th> */}
                                    <th
                                        style={{
                                            width: "13%",
                                            position: "relative",
                                        }}
                                    >
                                        <div className="d-flex align-items-center justify-content-center">
                                            <div className="d-flex gap-1" onClick={() => setShowFilter(!showFilter)} style={{ cursor: "pointer" }}>
                                                <span>Report Status</span>
                                                <span style={{ position: "relative" }}>
                                                    <FaCaretDown

                                                        style={{ color: "white", cursor: "pointer", width: "16px", height: "16px" }}
                                                        title="Filter Report Status"
                                                    />
                                                </span>
                                            </div>
                                        </div>


                                    </th>

                                    <th style={{ width: "10%" }}> Action </th>
                                    {/* <th style={{ width: "8%" }}> Complaint </th> */}
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: '0.5rem' }} className="patient-list-small-font">
                                {(() => {
                                    // const filteredReports = currentPatientReport.filter((rec) => {
                                    //     if (!reportFilter) return true; 
                                    //     if (reportFilter === "Cancelled") return rec.MHL_Visit_Status__c === "Cancelled";
                                    //     return rec.PP_ReportStatus__c === reportFilter;
                                    // });

                                    // Use currentAvailableReports for AVAILABLE filter, otherwise use currentPatientReport
                                    const filteredPageReports = reportFilter === "AVAILABLE"
                                        ? currentAvailableReports
                                        : currentPatientReport.filter((rec) => {
                                            if (!reportFilter) return true;
                                            if (reportFilter === "Cancelled") return rec.MHL_Visit_Status__c === "Cancelled";
                                            return rec.PP_ReportStatus__c === reportFilter;
                                        });
                                    if (filteredPageReports.length === 0) {
                                        return (
                                            <tr>
                                                <td colSpan="11" className="text-center">No Patient visits found</td>
                                            </tr>
                                        );
                                    }

                                    return filteredPageReports.map((rec, index) => (
                                        <tr className="patient-list-row" key={index}>
                                            {accessToDownloadReport &&
                                                (accessToDownloadWOSReport || accessToDownloadWSReport) && (
                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                        {rec.PP_ReportStatus__c === "AVAILABLE" && (
                                                            <input
                                                                type="checkbox"
                                                                onChange={() => handleCheckboxChange(rec)}
                                                                checked={isChecked(rec.Name)}
                                                                title="Select to include in Report List"
                                                            />
                                                        )}
                                                    </td>
                                                )}

                                            <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                {rec.MHL_PID__c}{" "}
                                            </td>
                                            <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                <Popover
                                                    content={
                                                        <div style={{ textAlign: "left" }}>
                                                            <p><strong>Patient Name:</strong> {rec.MHL_Patient_Name || "-"}</p>
                                                        </div>
                                                    }
                                                >
                                                    <span style={{ cursor: "pointer", fontWeight: "700" }}>

                                                        {rec.MHL_Patient_Name
                                                            ? rec.MHL_Patient_Name.length > 18
                                                                ? `${rec.MHL_Patient_Name.substring(0, 18)}...`
                                                                : rec.MHL_Patient_Name
                                                            : "-"}
                                                    </span>
                                                </Popover>

                                                <br />

                                                {rec.MHL_Patient_Gender || "-"}
                                                {rec.MHL_Patient_DOB && (
                                                    <> | {format(parseISO(rec.MHL_Patient_DOB), "dd-MMM-yyyy")}</>
                                                )}
                                            </td>


                                            {/* <td style={{ textAlign: "center", verticalAlign: "middle" }}>{rec.MHL_Doctor__c}</td> */}

                                            {/* VID */}
                                            <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                <Popover
                                                    content={
                                                        <div style={{ textAlign: "left" }}>
                                                            <p><strong>VID:</strong> {rec.Name || "-"}</p>
                                                            <p><strong>TRF ID:</strong> {rec.TRF_ID__c || "-"}</p>
                                                        </div>
                                                    }
                                                >
                                                    {/* Icon triggers popover */}
                                                    <FaInfoCircle color="green" size={13} className="mb-1" style={{ cursor: "pointer" }} /> &nbsp;
                                                </Popover>

                                                {/* Display full Name */}
                                                <strong>{rec.Name || "-"}</strong>
                                                <br />

                                                <div className="d-flex align-items-center gap-2">
                                                    <small style={{ fontSize: "11px", color: "#555" }}>
                                                        {rec.TRF_ID__c}
                                                    </small>

                                                    {/* Document / History Pending */}
                                                    {rec.Is_Document_Pending && (
                                                        <span
                                                            title="Pending documents/history"
                                                            style={{
                                                                display: "inline-flex",
                                                                alignItems: "center",
                                                                cursor: "pointer"
                                                            }}
                                                        >
                                                            <FaExclamationTriangle color="red" size={13} />
                                                        </span>
                                                    )}

                                                    {/* Sample Pending */}
                                                    {rec.Is_Sample_Pending && (
                                                        <span
                                                            title="Pending sample"
                                                            style={{
                                                                display: "inline-flex",
                                                                alignItems: "center",
                                                                cursor: "pointer"
                                                            }}
                                                        >
                                                            <FaFlask color="#f39c12" size={13} />
                                                        </span>
                                                    )}
                                                </div>

                                            </td>


                                            <td>{formatVisitDate(rec.MHL_Visit_Date__c)}</td>
                                            <td
                                                className="test-text-small"
                                                style={{ textAlign: "center", verticalAlign: "middle" }}
                                            >
                                                {rec?.MHL_Test_Details_List?.length === 1 && (
                                                    <>
                                                        {rec.MHL_Test_Details_List[0].MHL_TestName__c.length > 30 ? (
                                                            <Popover
                                                                content={
                                                                    <span>
                                                                        {rec.MHL_Test_Details_List[0].MHL_TestName__c}
                                                                    </span>
                                                                }
                                                            >
                                                                <span style={{ cursor: "pointer" }}>
                                                                    {rec.MHL_Test_Details_List[0].MHL_TestName__c.substring(
                                                                        0,
                                                                        30
                                                                    )}
                                                                    ...
                                                                </span>
                                                            </Popover>
                                                        ) : (
                                                            rec.MHL_Test_Details_List[0].MHL_TestName__c
                                                        )}
                                                    </>
                                                )}

                                                {rec.MHL_Test_Details_List?.length > 1 && (
                                                    <Popover
                                                        content={
                                                            <ul
                                                                className="list-unstyled"
                                                                style={{ textAlign: "left", paddingLeft: "2px", margin: 0 }}
                                                            >
                                                                {rec.MHL_Test_Details_List.map((test, index) => (
                                                                    <li key={index}>{test.MHL_TestName__c}</li>
                                                                ))}
                                                            </ul>
                                                        }
                                                    >
                                                        <span style={{ marginLeft: "5px", cursor: "pointer" }}>
                                                            {rec.MHL_Test_Details_List[0].MHL_TestName__c.length > 30
                                                                ? `${rec.MHL_Test_Details_List[0].MHL_TestName__c.substring(
                                                                    0,
                                                                    30
                                                                )}...`
                                                                : rec.MHL_Test_Details_List[0].MHL_TestName__c}
                                                            {` (+${rec.MHL_Test_Details_List.length - 1})`}
                                                        </span>
                                                    </Popover>
                                                )}
                                            </td>

                                            {/* <td style={{ textAlign: "center", verticalAlign: "middle" }}>{rec.MHL_Test_TAT_Date ? rec.MHL_Test_TAT_Date : "-"}</td> */}

                                            < td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                {
                                                    rec.MHL_Visit_Status__c === "Cancelled"
                                                        ? "N/A"
                                                        : rec.MHL_Test_TAT_Date || "-"
                                                }
                                            </td>

                                            <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                {rec.PP_ReportStatus__c === "PENDING" ? (
                                                    <span
                                                        style={{
                                                            backgroundColor: "#fff3cd",
                                                            color: "#856404",
                                                            padding: "5px 10px",
                                                            borderRadius: "5px",
                                                            fontSize: "12px",
                                                            display: "inline-block",
                                                            minWidth: "80px",
                                                        }}
                                                    >
                                                        PENDING
                                                    </span>
                                                ) : rec.PP_ReportStatus__c === "AVAILABLE" ? (
                                                    <span
                                                        style={{
                                                            backgroundColor: "#d4edda",
                                                            color: "#155724",
                                                            padding: "5px 10px",
                                                            borderRadius: "5px",
                                                            fontSize: "12px",
                                                            display: "inline-block",
                                                            minWidth: "80px",
                                                        }}
                                                    >
                                                        AVAILABLE
                                                    </span>
                                                ) : (
                                                    <span
                                                        style={{
                                                            backgroundColor: "#f8d7da",
                                                            color: "#721c24",
                                                            padding: "5px 10px",
                                                            borderRadius: "5px",
                                                            fontSize: "12px",
                                                            display: "inline-block",
                                                            minWidth: "80px",
                                                        }}
                                                    >
                                                        {rec.PP_ReportStatus__c}
                                                    </span>
                                                )}
                                            </td>

                                            {/* <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                                                        {rec.MHL_Visit_Status__c === "Cancelled" ? (
                                                                                            <span style={{ backgroundColor: '#f8d7da', color: '#721c24', padding: '5px 10px', borderRadius: '5px', fontSize: '12px', display: 'inline-block', minWidth: '80px' }}>
                                                                                                {rec.MHL_Visit_Status__c}
                                                                                            </span>
                                                                                        ) : rec.WS_Report__c && rec.WS_Report__c.trim() !== "" ? (
                                                                                            rec.MHL_Visit_Status__c === "Completed" ? (
                                                                                                <span style={{ cursor: 'pointer', backgroundColor: '#d4edda', color: '#155724', padding: '5px 10px', borderRadius: '5px', fontSize: '12px', display: 'inline-block', minWidth: '80px' }}>
                                                                                                    AVAILABLE
                                                                                                </span>
                                                                                            ) : (
                                                                                                <span style={{ backgroundColor: '#e2e3e5', color: '#383d41', padding: '5px 10px', borderRadius: '5px', fontSize: '12px', display: 'inline-block', minWidth: '80px' }}>
                                                                                                    {rec.MHL_Visit_Status__c}
                                                                                                </span>
                                                                                            )
                                                                                        ) : (
                                                                                            <span style={{ backgroundColor: '#fff3cd', color: '#856404', padding: '5px 10px', borderRadius: '5px', fontSize: '12px', display: 'inline-block', minWidth: '80px' }}>
                                                                                                PENDING
                                                                                            </span>
                                                                                        )}
                                                                                    </td> */}

                                            <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                <div className="d-flex align-items-center gap-2">
                                                    <div className="d-flex gap-2 align-items-center">
                                                        <span
                                                            disabled={loading}
                                                            className="d-flex"
                                                            title="View Details"
                                                            style={{
                                                                display: "inline-block",
                                                                transition: "transform 0.2s",
                                                                cursor: "pointer",
                                                                fontSize: "12px",
                                                            }}
                                                            onMouseEnter={(e) =>
                                                                (e.currentTarget.style.transform = "scale(1.2)")
                                                            }
                                                            onMouseLeave={(e) =>
                                                                (e.currentTarget.style.transform = "scale(1)")
                                                            }
                                                            onClick={() => {
                                                                GetPatientTestDetailTAT(rec);
                                                            }}
                                                        >
                                                            <Eye style={{ color: "green" }} />
                                                        </span>

                                                        {accessToRaiseComplaintRights &&
                                                            <span
                                                                disabled={loading}
                                                                className="d-flex"
                                                                title="Raise Complaint"
                                                                style={{
                                                                    display: "inline-block",
                                                                    transition: "transform 0.2s",
                                                                    cursor: "pointer",
                                                                    fontSize: "20px",
                                                                }}
                                                                onMouseEnter={(e) =>
                                                                    (e.currentTarget.style.transform = "scale(1.2)")
                                                                }
                                                                onMouseLeave={(e) =>
                                                                    (e.currentTarget.style.transform = "scale(1)")
                                                                }
                                                                onClick={() => {
                                                                    handleRaiseComplaint();
                                                                    setSelectedVID(rec.Name);
                                                                }}
                                                            >
                                                                <FaComments style={{ color: "green" }} />
                                                            </span>
                                                        }


                                                        {/* {accessToSendReportOnEmail && */}
                                                        {(accessToSendWS_ReportOnEmail || accessToSendWOS_ReportOnEmail) &&
                                                            rec.PP_ReportStatus__c === "AVAILABLE" && (
                                                                <span
                                                                    title="Send Report"
                                                                    style={{
                                                                        display: "inline-block",
                                                                        transition: "transform 0.2s",
                                                                        cursor: "pointer",
                                                                        fontSize: "15px",
                                                                    }}
                                                                    onMouseEnter={(e) =>
                                                                        (e.currentTarget.style.transform = "scale(1.2)")
                                                                    }
                                                                    onMouseLeave={(e) =>
                                                                        (e.currentTarget.style.transform = "scale(1)")
                                                                    }
                                                                >
                                                                    <FaPaperPlane
                                                                        className="d-flex"
                                                                        style={{ color: "green" }}
                                                                        onClick={() => handleSendReportClick(rec)}
                                                                    />
                                                                </span>
                                                            )}
                                                    </div>
                                                </div>
                                            </td>

                                            {/* <td style={{ textAlign: "center", verticalAlign: "middle" }}>

                                                                                        <div className="d-flex gap-2 justify-content-center align-items-center">
                                                                                            <span
                                                                                                disabled={loading}
                                                                                                title="Raise Complaint"
                                                                                                style={{
                                                                                                    display: 'inline-block',
                                                                                                    transition: 'transform 0.2s',
                                                                                                    cursor: 'pointer',
                                                                                                    fontSize: '12px'
                                                                                                }}
                                                                                                onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.2)'}
                                                                                                onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                                                                                                onClick={() => { handleRaiseComplaint() }}
                                                                                            >
                                                                                                <Plus style={{ color: "green" }} />
                                                                                            </span>
                                                                                        </div>

                                                                                    </td> */}
                                        </tr>
                                    ))
                                })()}
                            </tbody>
                        </table>
                    </div>

                    {showFilter && (
                        <>
                            {/* Backdrop */}
                            <div className="filter-backdrop" onClick={() => setShowFilter(false)} />

                            {/* Filter dropdown */}
                            <div className="filter-dropdown" ref={filterDropdownRef}>
                                {[
                                    "", // All option
                                    ...Array.from(
                                        new Set(
                                            patientReportList.map(rec =>
                                                rec.MHL_Visit_Status__c === "Cancelled"
                                                    ? "Cancelled"
                                                    : rec.PP_ReportStatus__c
                                            )
                                        )
                                    )
                                ].map((status) => (
                                    <div
                                        key={status}
                                        className={`filter-option ${reportFilter === status ? "selected" : ""}`}
                                        onClick={() => handleFilterClick(status)}
                                    >
                                        {status === "" ? "All" : status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()}
                                    </div>
                                ))}
                            </div>
                        </>
                    )}



                    {showRaiseComplaintModal && (
                        <RaiseComplaint
                            showModal={showRaiseComplaintModal}
                            setShowModal={setShowRaiseComplaintModal}
                            vid={selectedVID}
                        />
                    )}

                    {
                        filteredReports.length > itemsPerPage && (
                            <CommonPagination
                                pageList={filteredReports}
                                currentPage={currentPage}
                                itemsPerPage={itemsPerPage}
                                setCurrentPage={setCurrentPage}
                            />
                        )
                    }

                    {/* {
                        patientReportList.length > itemsPerPage ? (
                            <CommonPagination
                                pageList={patientReportList}
                                currentPage={currentPage}
                                itemsPerPage={itemsPerPage}
                                setCurrentPage={setCurrentPage}
                            />

                        ) : null} */}
                </div >

                {showBulkDownloadReportOptionModal && (
                    <div className="modal show d-block" tabIndex="-1">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header p-2">
                                    <h5 className="modal-title">Select Report Option</h5>
                                    <button
                                        type="button"
                                        className="btn-close pr-3"
                                        // style={{ "paddingRight":"2px" }}
                                        onClick={() => setShowBulkDownloadReportOptionModal(false)}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <p className="mb-2">Select report type for bulk download:</p>
                                    {accessToDownloadWSReport && (
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="downloadOption"
                                                id="withStationary"
                                                value="with"
                                                checked={downloadOption === "with"}
                                                onChange={(e) => setDownloadOption(e.target.value)}
                                            />
                                            <label className="form-check-label" htmlFor="withStationary">
                                                With Stationary Report
                                            </label>
                                        </div>
                                    )}
                                    {accessToDownloadWOSReport && (
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="downloadOption"
                                                id="withoutStationary"
                                                value="without"
                                                checked={downloadOption === "without"}
                                                onChange={(e) => setDownloadOption(e.target.value)}
                                            />
                                            <label className="form-check-label" htmlFor="withoutStationary">
                                                Without Stationary Report
                                            </label>
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer p-2">
                                    <button className="btn btn-danger" onClick={() => setShowBulkDownloadReportOptionModal(false)}>
                                        Close
                                    </button>
                                    <button className="btn btn-success" onClick={handleProceed}>
                                        Proceed
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )
                }


                {
                    showPatientTestTATModal && (
                        // <div className="modal-backdrop">
                        //     <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                        //         <div className="modal-dialog modal-lg" role="document">
                        //             <div className="modal-content">
                        //                 <div className="modal-header p-2">
                        //                     <h5 className="modal-title">Patient & Test Details</h5>
                        //                     <button type="button" className="btn-close" onClick={handlePatientTestTATClose}></button>
                        //                 </div>
                        //                 <div className="modal-body p-2" style={{ fontSize: "13px" }}>

                        //                     <div className="row mb-2 g-2">
                        //                         <div className="col-md-8">
                        //                             <div className="card border-success h-100 rounded-3 small-card">
                        //                                 <div className="card-header bg-success text-white py-2 rounded-top-3">
                        //                                     Patient Details
                        //                                 </div>
                        //                                 <div className="card-body px-2 py-1">
                        //                                     <div className="row">
                        //                                         <div className="col-md-7 mb-1">
                        //                                             <i className="fas fa-user-circle mr-2"></i> Name: {patient.FirstName}
                        //                                         </div>
                        //                                         <div className="col-md-5 mb-1">
                        //                                             <i className="fas fa-calendar-alt mr-2"></i> DOB: {patient.DOB || "N/A"}
                        //                                         </div>
                        //                                         <div
                        //                                             className="col-md-7 mb-1"
                        //                                             style={{ fontSize: (patient.EmailId && patient.EmailId.length > 33) ? '12.4px' : 'inherit' }}
                        //                                         >
                        //                                             <i className="fas fa-envelope mr-2"></i> Email: {patient.EmailId || "N/A"}
                        //                                         </div>
                        //                                         <div className="col-md-5 mb-1">
                        //                                             <i className="fas fa-venus-mars mr-1"></i> Gender: {patient.Gender}
                        //                                         </div>
                        //                                         <div className="col-md-7 mb-1">
                        //                                             <i className="fas fa-phone-alt mr-2"></i> Phone: {patient.PhoneNumber || "N/A"}
                        //                                         </div>
                        //                                         <div className="col-md-5 mb-1">
                        //                                             <i className="fas fa-id-badge mr-2"></i> PID: {patient.PatientNumber}
                        //                                         </div>
                        //                                     </div>
                        //                                 </div>

                        //                             </div>
                        //                         </div>

                        //                         <div className="col-md-4">
                        //                             <div className="card h-100 border-success rounded-3 small-card">
                        //                                 <div className="card-header bg-success text-white py-2 rounded-top-3">
                        //                                     Visit Details
                        //                                 </div>
                        //                                 <div className="card-body px-2 py-1">
                        //                                     <div className="mb-1">
                        //                                         <i className="fas fa-id-card mr-1"></i> VID: {visit.VisitNumber}
                        //                                     </div>
                        //                                     <div className="mb-1">
                        //                                         <i className="fas fa-calendar-day mr-2"></i> Visit Date: {visit.VisitDate}
                        //                                     </div>
                        //                                     {/* {(reportURL || reportWOSURL) && (
                        //                                         <>
                        //                                             <div
                        //                                                 className="input-group shadow-sm"
                        //                                                 style={{
                        //                                                     maxWidth: '320px',
                        //                                                     paddingTop: '5px',
                        //                                                     height: '38px',
                        //                                                 }}
                        //                                             >
                        //                                                 <select
                        //                                                     className="form-select rounded-start"
                        //                                                     value={selectedURL}
                        //                                                     onChange={(e) => setSelectedURL(e.target.value)}
                        //                                                     style={{
                        //                                                         fontSize: '0.9rem',
                        //                                                         padding: '6px 10px',
                        //                                                         height: '100%',
                        //                                                     }}
                        //                                                 >
                        //                                                     <option value="">Select Report</option>
                        //                                                     {reportURL && <option value={reportURL}>Report (W3)</option>}
                        //                                                     {reportWOSURL && <option value={reportWOSURL}>Report (WOS)</option>}
                        //                                                 </select>
                        //                                                 <button
                        //                                                     className="btn btn-success rounded-end d-flex align-items-center justify-content-center"
                        //                                                     type="button"
                        //                                                     onClick={handleDownload}
                        //                                                     title="Download Report"
                        //                                                     style={{
                        //                                                         padding: '0 12px',
                        //                                                         height: '100%',
                        //                                                         fontSize: '1rem',
                        //                                                         transition: '0.2s ease-in-out',
                        //                                                     }}
                        //                                                 >
                        //                                                     <FaDownload />
                        //                                                 </button>
                        //                                             </div>

                        //                                         </>

                        //                                     )} */}
                        //                                     {/* <div className="mb-1"><strong>Visit ID:</strong> {visit.ExternalVisitId}</div> */}
                        //                                 </div>

                        //                             </div>
                        //                         </div>
                        //                     </div>

                        //                     <div>
                        //                         <h6 className="text-dark border-bottom pb-1">Sample Details</h6>
                        //                         <div className="table-responsive" style={{ maxHeight: '180px', overflowY: 'auto' }}>
                        //                             <table className="table table-bordered custom-table" >
                        //                                 <thead className="bg-success">
                        //                                     <tr>
                        //                                         <th>Sample ID</th>
                        //                                         <th>Sample Name</th>
                        //                                         <th>Container</th>
                        //                                         <th>Status</th>
                        //                                         <th>Collected At</th>
                        //                                     </tr>
                        //                                 </thead>
                        //                                 <tbody>
                        //                                     {samples.map((s, idx) => (
                        //                                         <tr key={idx}>
                        //                                             <td>{s.SampleID}</td>
                        //                                             <td>{s.SampleName}</td>
                        //                                             <td>{s.ContainerName}</td>
                        //                                             <td>{s.SampleStatus}</td>
                        //                                             <td>{s.SampleCollectedAt}</td>
                        //                                         </tr>
                        //                                     ))}
                        //                                 </tbody>
                        //                             </table>
                        //                         </div>
                        //                     </div>
                        //                     <div>
                        //                         <div className="d-flex justify-content-between align-items-center border-bottom mb-2">
                        //                             <h6 className="text-dark mb-1">Test Details</h6>
                        //                             <div className="d-flex gap-2 mb-2">
                        //                                 {reportURL && (
                        //                                     <button
                        //                                         className="btn btn-success"
                        //                                         type="button"
                        //                                         onClick={() => { handleReportDownload(reportURL); }}
                        //                                         title="Report with Stationary"
                        //                                     >
                        //                                         Download Report (WS)
                        //                                     </button>
                        //                                 )}
                        //                                 {reportWOSURL &&
                        //                                     !["APSC", "DAPSC"].includes(userInfo.Partner_Account_Details.MHL_Business_Type_B2C__c) && (
                        //                                         <button
                        //                                             className="btn btn-success"
                        //                                             type="button"
                        //                                             onClick={() => handleReportDownload(reportWOSURL)}
                        //                                             title="Report without Stationary"
                        //                                         >
                        //                                             Download Report (WOS)
                        //                                         </button>
                        //                                     )}
                        //                             </div>
                        //                         </div>

                        //                         <div style={{ maxHeight: '180px', overflowY: 'auto' }}>
                        //                             <table className="table table-bordered custom-table">
                        //                                 <thead className="table-light">
                        //                                     <tr>
                        //                                         <th>Test Code</th>
                        //                                         <th>Test Name</th>
                        //                                         <th>Type</th>
                        //                                         <th>Status</th>
                        //                                         <th>Report TAT</th>
                        //                                     </tr>
                        //                                 </thead>
                        //                                 <tbody>
                        //                                     {tests.map((t, idx) => (
                        //                                         <tr key={idx}>
                        //                                             <td>{t.TestCode}</td>
                        //                                             <td>{t.TestName}</td>
                        //                                             <td>{t.TestType}</td>
                        //                                             <td>{t.TestStatus}</td>
                        //                                             <td >
                        //                                                 {t.ReportTAT}
                        //                                                 {t.ShowAlert && reportURL == "" && reportWOSURL == "" && (
                        //                                                     <Popover content={"Report is Delayed"}>
                        //                                                         <span className="d-flex">
                        //                                                             <AlarmClock
                        //                                                                 className="vibrate"
                        //                                                                 stroke="red"
                        //                                                                 size={18}
                        //                                                                 style={{ marginLeft: '5px' }}
                        //                                                             />
                        //                                                         </span>
                        //                                                     </Popover>
                        //                                                 )}
                        //                                             </td>
                        //                                         </tr>
                        //                                     ))}
                        //                                 </tbody>
                        //                             </table>
                        //                         </div>
                        //                     </div>

                        //                     {(!reportURL && !reportWOSURL) && (
                        //                         <div className="alert alert-warning py-2 px-3 m-0">
                        //                             Your test report will be available shortly. Please check back later.
                        //                         </div>
                        //                     )}

                        //                     {/* <div className="d-flex gap-3 align-items-center justify-content-end">
                        //                         {reportURL && (
                        //                             <button
                        //                                 className="btn btn-success me-2"
                        //                                 type="button"
                        //                                 onClick={() => { handleReportDownload(reportURL); }}
                        //                                 title="Report with Stationary"
                        //                             >
                        //                                 Download Report (WS)
                        //                             </button>
                        //                         )}
                        //                         {reportWOSURL && (
                        //                             <button
                        //                                 className="btn btn-success me-2"
                        //                                 type="button"
                        //                                 onClick={() => { handleReportDownload(reportWOSURL); }}
                        //                                 title="Report without Stationary"
                        //                             >
                        //                                 Download Report (WOS)
                        //                             </button>
                        //                         )}
                        //                     </div> */}
                        //                 </div>

                        //                 <div className="modal-footer mt-1 mb-1 pt-1 pb-0 pr-1">
                        //                     <button type="button" className="btn btn-danger" onClick={handlePatientTestTATClose}>Close</button>
                        //                 </div>
                        //             </div>
                        //         </div>
                        //     </div>
                        // </div>

                        <PatientTestDetailsModalComponent
                            visit={visit}
                            handlePatientTestTATClose={handlePatientTestTATClose}
                            patient={patient}
                            samples={samples}
                            reportURL={reportURL}
                            handleReportDownload={handleReportDownload}
                            reportWOSURL={reportWOSURL}
                            visitStatus={visitStatus}
                            tests={tests}
                            crmVisitDetails={crmVisitDetails}
                        />
                    )
                }

                {
                    showPopup && (
                        <div className="modal-backdrop">
                            <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                                <div className="modal-dialog modal-md" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header p-2">
                                            <h5 className="modal-title">Select Download Option</h5>
                                            <button type="button" className="btn-close" onClick={() => setShowPopup(false)}></button>
                                        </div>

                                        <div className="modal-body p-2 text-center" style={{ fontSize: "12px" }}>
                                            <div className="d-flex flex-column gap-1">
                                                <div className="button-row">
                                                    <button onClick={handleDownloadWithStationary} className="btn custom-sumbitbtn">
                                                        Download with Stationary
                                                    </button>
                                                    <button onClick={handleDownloadWithoutStationary} className="btn custom-sumbitbtn">
                                                        Download without Stationary
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="modal-footer p-2">
                                            <button type="button" className="btn btn-danger" onClick={() => setShowPopup(false)}>
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }

                {
                    sendReportModalShow && (
                        <div className="modal-backdrop">
                            <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                                <div className="modal-dialog modal-sm custom-modal-com" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header p-2">
                                            <h5 className="modal-title">Send Report</h5>
                                            <button type="button" disabled={loading} className="btn-close" onClick={handleSendReportModalClose}></button>
                                        </div>
                                        <div className="modal-body" style={{ position: 'relative', paddingBottom: '60px' }}>
                                            <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                                                <div>
                                                    <div className="">
                                                        <label className="fw-bold required">Email</label>
                                                        <span
                                                            style={{ position: 'relative', display: 'inline-block' }}
                                                            onMouseEnter={() => setShowTooltip(true)}
                                                            onMouseLeave={() => setShowTooltip(false)}
                                                        >
                                                            <FaExclamationCircle
                                                                style={{
                                                                    color: '#007bff',
                                                                    cursor: 'pointer',
                                                                    fontSize: '14px'
                                                                }}
                                                            />
                                                            {showTooltip && (
                                                                <div
                                                                    style={{
                                                                        position: 'absolute',
                                                                        bottom: '125%',
                                                                        left: '50%',
                                                                        transform: 'translateX(-50%)',
                                                                        backgroundColor: '#333',
                                                                        color: 'white',
                                                                        padding: '5px 8px',
                                                                        borderRadius: '4px',
                                                                        fontSize: '12px',
                                                                        fontWeight: 'normal',
                                                                        whiteSpace: 'nowrap',
                                                                        zIndex: 1000,
                                                                        animation: 'fadeIn 0.3s ease-in-out'
                                                                    }}
                                                                >
                                                                    To enter multiple email use comma (,) <br />
                                                                    Eg: first_email@gmail.com, second_email.gmail.com
                                                                    <div
                                                                        style={{
                                                                            position: 'absolute',
                                                                            top: '100%',
                                                                            left: '50%',
                                                                            transform: 'translateX(-50%)',
                                                                            borderLeft: '5px solid transparent',
                                                                            borderRight: '5px solid transparent',
                                                                            borderTop: '5px solid #333'
                                                                        }}
                                                                    />
                                                                </div>
                                                            )}
                                                        </span>
                                                    </div>
                                                    <input
                                                        type="text"
                                                        placeholder="Enter email here"
                                                        className="form-control"
                                                        {...register("Email", {
                                                            required: "Please enter email(s)",
                                                            validate: (value) => {
                                                                const emails = value.split(',').map(email => email.trim()).filter(Boolean);
                                                                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                                                                const invalidEmails = emails.filter(email => !emailRegex.test(email));
                                                                if (invalidEmails.length > 0) {
                                                                    return `Invalid email(s): ${invalidEmails.join(', ')}`;
                                                                }
                                                                return true;
                                                            }
                                                        })}
                                                        defaultValue={userData?.Role_Name === "Sales-Admin" ? userData?.Partner_EmailId : selectedPatient?.MHL_Patient_Email}
                                                        disabled={userData?.Role_Name === "Sales-Admin"}
                                                    // defaultValue={selectedPatient.MHL_Patient__r?.MHL_Email__c ? selectedPatient.MHL_Patient__r?.MHL_Email__c: null}
                                                    />
                                                    {errors.Email && (
                                                        <p className="text-danger required_error">{errors.Email.message}</p>
                                                    )}
                                                </div>

                                                <div className="mt-3">
                                                    <label className="fw-bold mb-0-5 required">Select Report Type</label>
                                                    <select
                                                        className="form-control"
                                                        defaultValue={selectedReportType}
                                                        onChange={(e) => setSelectedReportType(e.target.value)}
                                                        {...register("Report_Type", { required: "Select Report Type" })}
                                                    >
                                                        <option value="">-- Select an option --</option>
                                                        {selectedPatient.WS_Report__c && accessToSendWS_ReportOnEmail && (<option value="WS">With Stationary (WS)</option>)}
                                                        {selectedPatient.WOS_Report__c && accessToSendWOS_ReportOnEmail && (<option value="WOS">Without Stationary (WOS)</option>)}
                                                    </select>
                                                    {errors.Report_Type && (<p className="text-danger required_error">{errors.Report_Type.message}</p>)}
                                                </div>

                                                <div style={{ position: 'absolute', bottom: '15px', right: '15px' }}>
                                                    <button type="submit" disabled={emailSendLoading} className="btn btn-success">{emailSendLoading ? "Sending..." : "Send"}</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </CommonContainer >
        </>
    );
};

export default PatientVisitComponent;